import styled from "styled-components";

export const StyledTextArea = styled("textarea")`
  resize: none;
  height: 200px;
  font-size: 12px;
  background-color:#e6e6e6;
  font-family: 'IRANSansWeb';
  text-align:right;
  rows:10;
`;

export const SMSTextArea = styled("textarea")`
  resize: none;
  height: 50px;
  font-size: 12px;
  background-color:#e6e6e6;
  font-family: 'IRANSansWeb';
  text-align:right;
  rows:3;
`;